import Api from '../../api'
import axios from '@/js/api'
// import Vue from 'vue'
import router from '../../router'
const state = {
	data:[],
	rolesList:[],
	listParameter:{
		enable:'-1',
		name:'',
		pageIndex:1,
		pageCount:999999
	},
	userlist:[],
	userListParameter:{
		enable:'-1',
		name:'',
		pageIndex:1,
		pageCount:10,
		HospitalGuid:''
	},
	regionList:[],
	roleTotal:0,
	regionUsersList:[]
};
const getters = {

};
const mutations = {
	setTreeList(state,arr){
		state.data = arr.data.Modules;
	},
	setRolesList(state,arr){
		state.rolesList = arr.Roles;
		state.roleTotal = arr.TotalCount;
	},
	setList(state,arr){
		state.userlist = arr;
	},
	setRegionList(state,arr){
		state.regionList = arr.map((item)=>{
			item.label = item.Name;
			item.children = item.Children.map((items)=>{
				items.label = items.Name;
				return items
			})
			return item
		});
	}
};
const actions = {
	GetModulesByGroup({
		state,
		commit,
		dispatch
	}) {
		commit('breadcrumb/setLoading',true,{root:true})
		axios.ajaxGet('get', Api.api.admin.GetModulesByGroup, {
			ModuleGuid:''
		}).then(res => {
			 commit('setTreeList',res)
			 commit('breadcrumb/setLoading',false,{root:true})
		})
	},
	GetRoles(context,arr) {
		context.commit('breadcrumb/setLoading',true,{root:true})
		context.rootState.admin.listParameter.enable = arr.enable;
		if (arr.name == '') {
			context.rootState.admin.listParameter.name = arr.name;
		}
		return axios.ajaxGet('get', Api.api.admin.GetRoles,context.state.listParameter).then(res => {
			if (res.data.StatusCode == 200) {
				context.commit('setRolesList',res.data)
				context.commit('breadcrumb/setLoading',false,{root:true})
			}
		}).finally(() => {});
	},
	GetList(context,arr) {
		context.rootState.breadcrumb.loading = true;
		axios.ajaxGet('get', Api.api.admin.GetList,context.state.userListParameter).then(res => {
			if (res.data.StatusCode == 200) {
				context.commit('setList',res.data)
				context.rootState.breadcrumb.loading = false;
			}
		})
	},
	GetRegionList(context,arr) {
		context.rootState.breadcrumb.loading = true;
		return axios.ajaxGet('get', Api.api.admin.GetRegionsNoHospital).then(res => {
			if (res.data.StatusCode == 200) {
				context.commit('setRegionList',res.data.Regions)
				context.rootState.breadcrumb.loading = false;
			}
		}).finally(() => {});
	},
	//获取区域管理者
	GetRegionUsers({
		state,
		commit,
		dispatch
	},arr) {
		axios.ajaxGet('get', Api.api.admin.GetRegionUsers,arr).then(res => {
			if (res.data.StatusCode == 200) {
				state.regionUsersList = res.data;
			}
		})
	},
	//添加区域管理员
	AddRegionUser({
		state,
		commit,
		dispatch
	},arr) {
		return axios.ajaxPost('post', Api.api.admin.AddRegionUser,arr).then(res => {
			dispatch('GetRegionUsers',{regionGuid:arr.RegionGuid});
		}).finally(() => {});
	},
	//删除区域管理员
	DeleteRegionUser({
		state,
		commit,
		dispatch
	},arr) {
		axios.ajaxPost('post', Api.api.admin.DeleteRegionUser,arr).then(res => {
			dispatch('GetRegionUsers',{regionGuid:arr.RegionGuid});
		})
	},
	//修改用户归属中心
	AddUser2Hospital({
		state,
		commit,
		dispatch
	},arr) {
		return axios.ajaxPost('post', Api.api.admin.AddUser2Hospital,arr).then(res => {}).finally(() => {});
	},
}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}